import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=56d58f70&"
import script from "./TableLoader.vue?vue&type=script&lang=js&"
export * from "./TableLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports